import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('commonCodeStore', Object.keys(state)),
	...mapGetters('commonCodeStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('commonCodeStore', Object.keys(actions)),
	...mapMutations('commonCodeStore', Object.keys(mutations))
};
